var map = {
	"./plenum_cablato_2zone.png": 6704,
	"./plenum_cablato_3zone.png": 5166,
	"./plenum_cablato_4zone.png": 7344,
	"./plenum_cablato_5zone.png": 1817,
	"./plenum_cablato_6zone.png": 1782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6337;